<template>
    <div class="publication__edit content-width">

        <div class="publication__edit-wrapper" v-for="c in initial">
            <component :is="c.component.name" :server="server" :key="c.component.name"></component>
        </div>

        <div class="publication__edit-wrapper" v-show="createCategory === 'fundraising'">
            <publication-donations :server="server" />
        </div>

    </div>
</template>

<script>


import catalog from "../../../store/catalog";

const components = [
    { component: PublicationCreatePet },
    { component: SelectLocation },
    { component: PetCategories },
    { component: PetProfile },
    { component: PublicationEditPreview },
    { component: PublicationSliderGallery },
    { component: PetFilters },
]

import StateMixin from "../mixins/StateMixin";

import PublicationCreatePet from './PublicationCreatePet';
import SelectLocation from './SelectLocation';
import PetCategories from './PetCategories';
import PetProfile from './PetProfile';
import PublicationEditPreview from './PublicationEditPreview';
import PublicationSliderGallery from './PublicationSliderGallery';
import PetFilters from './PetFilters';
import PublicationDonations from './PublicationDonations';


export default {
    name: "PublicationEdit",
    props: ['server'],
    mixins: [StateMixin],
    components: {
        PublicationCreatePet, SelectLocation, PetCategories, PetProfile, PublicationEditPreview,
        PublicationSliderGallery, PetFilters, PublicationDonations
    },

    computed: {
        initial() {
            return components
        },

        createCategory(){ return this.GET_BY_KEY('create_category') },

    },

    methods: {
        handleSliderHeight(){
            this.$parent.handleSliderHeight()
        },

        isValid(){
           const v = this.$children.map( e => {
               return e.isValid();
           } );

           if( v.includes(false) ){
               this.$emit('parent-update', false );
               return false
           }

           this.$emit('parent-update', true );
           return true

        }

    },

}
</script>

<style scoped>

</style>
